import { tokens } from '@airtel/air-design-system';
export var defaultProps = {
  status: 'SUCCESS',
  theme: 'light',
  collapsedState: {
    isCollapsible: false,
    infoArrayCollapsibleLimit: 3,
    collapsedCtaText: 'View More',
    expandedCtaText: 'View Less',
    collapsedCtaIcon: 'DownChevronIcon',
    expandedCtaIcon: 'UpChevronIcon'
  },
  statusCardProps: {
    imageProps: {
      url: 'http://127.0.0.1:8080/assets/success.svg',
      iconDimension: {
        width: 210,
        height: 150
      },
      iconStyle: {}
    },
    title: 'Thank you for making a payment',
    subtitle: [{
      text: 'Transaction number :',
      type: 'body-para-md',
      style: {
        fontSize: tokens.spacing.SPACING_16,
        lineHeight: tokens.spacing.SPACING_24,
        color: '#696B6F',
        paddingBottom: '4px'
      }
    }, {
      text: '12345678ASDFH',
      isHyperLink: true,
      type: 'body-para-md',
      color: '#027bfc'
    }],
    description: "Your payment for the Airtel Business Office has been successfully deducted. We'll email you a payment confirmation with details."
  },
  infoSectionProps: {
    infoTitle: 'Transaction Details',
    infoSubtitle: 'Info description',
    infoArray: [{
      infoKey: 'Invoice number',
      infoValue: 'BA12345',
      hyperLink: null
    }, {
      infoKey: 'Transaction number',
      infoValue: 'ABCD12345678',
      hyperLink: null
    }, {
      infoKey: 'Mode of payment',
      infoValue: 'UPI',
      hyperLink: null
    }, {
      infoKey: 'Payment posting status',
      infoValue: 'Completed',
      hyperLink: {
        title: 'Refresh',
        onPressHyperLink: null
      }
    }, {
      infoKey: 'Transaction Amount',
      infoValue: '₹ 20,000',
      hyperLink: {
        title: 'View Details',
        onPressHyperLink: null
      }
    }],
    infoNavigationArray: [{
      multiText: [{
        text: 'Want to see previous payment info?',
        style: {
          marginRight: '4px'
        }
      }, {
        color: '#027bfc',
        text: ' View payment history',
        isHyperLink: true
      }]
    }, {
      multiText: [{
        text: 'Facing a problem?',
        style: {
          marginRight: '4px'
        }
      }, {
        color: '#027bfc',
        text: 'Raise an issue',
        isHyperLink: true
      }]
    }, {
      multiText: [{
        text: 'Need to know more?',
        style: {
          marginRight: '4px'
        }
      }, {
        color: '#027bfc',
        text: 'Get help',
        isHyperLink: true
      }]
    }],
    buttonProps: [{
      title: 'Make Another Payment',
      actionCtaPressMetaData: null,
      type: 'primary',
      style: {}
    }, {
      title: 'Go To Home Page',
      actionCtaPressMetaData: null,
      type: 'secondary',
      style: {}
    }]
  },
  type: 'svg',
  svg: {
    iconName: 'TickIcon',
    svgBackgroundProps: {
      type: 'SUCCESS'
    }
  }
};